export const en = {
  // Auth
  'auth.login': 'Sign in',
  'auth.register': 'Sign up',
  'auth.logout': 'Sign out',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.username': 'Username',
  'auth.confirmPassword': 'Confirm password',
  'auth.forgotPassword': 'Forgot password?',
  'auth.resetPassword': 'Reset password',
  'auth.resetPasswordDesc': 'Enter your email address and we\'ll send you a reset link.',
  'auth.sendResetLink': 'Send link',
  'auth.resetLinkSent': 'A reset link has been sent to {{email}}.',
  'auth.backToLogin': 'Back to login',
  'auth.noAccount': 'No account yet?',
  'auth.hasAccount': 'Already have an account?',
  'auth.usernameAvailable': 'Available',
  'auth.usernameTaken': 'Taken',
  'auth.usernameInvalid': 'Letters and numbers only, max 10 characters',
  'auth.usernameChecking': 'Checking...',
  'auth.passwordMismatch': 'Passwords do not match',
  'auth.loginWithGoogle': 'Sign in with Google',
  'auth.orDivider': 'or',
  'auth.logoutMessage': 'You have been signed out.',

  // Account / Settings
  'account.title': 'My Account',
  'account.profile': 'Profile',
  'account.changeEmail': 'Change email',
  'account.changePassword': 'Change password',
  'account.changeAddress': 'Change address',
  'account.newEmail': 'New email',
  'account.currentPassword': 'Current password',
  'account.newPassword': 'New password',
  'account.confirmNewPassword': 'Confirm new password',
  'account.street': 'Street',
  'account.zip': 'ZIP code',
  'account.city': 'City',
  'account.country': 'Country',
  'account.save': 'Save',
  'account.saved': 'Saved!',
  'account.emailConfirmation': 'A confirmation email has been sent to {{email}}.',
  'account.passwordChanged': 'Password changed successfully.',
  'account.memberSince': 'Member since {{date}}',

  // Home
  'home.welcome': 'Welcome',
  'home.welcomeGuest': 'Welcome, Guest',
  'home.description': 'Your starting point for everything.',

  // General
  'general.loading': 'Loading...',
  'general.error': 'Error',
  'general.success': 'Success',
  'general.cancel': 'Cancel',
  'general.delete': 'Delete',
  'songbook.duration': 'Duration',

  // Songbook
  'songbook.title': 'Songbook',
  'songbook.newSong': 'New Song',
  'songbook.untitled': 'Untitled',
  'songbook.noSongs': 'No songs yet.',
  'songbook.deleteSong': 'Delete song',
  'songbook.deleteConfirm': 'Really delete this song?',
  'songbook.saved': 'Saved',
  'songbook.saving': 'Saving...',
  'songbook.loginRequired': 'Please sign in to create songs.',
  'songbook.addChord': 'Chord',
  'songbook.addTab': 'Tab',
  'songbook.chordName': 'Chord name (e.g. Am, G7)',
  'songbook.add': 'Add',
  'songbook.moveUp': 'Move up',
  'songbook.moveDown': 'Move down',
  'songbook.delete': 'Delete',
  'songbook.songTitle': 'Song title',
  'songbook.songInfo': 'General Info',
  'songbook.songInfoPlaceholder': 'Tempo, time signature, tuning, notes ...',
  'songbook.songNotes': 'Song notes',
  'songbook.songNotesPlaceholder': 'Notes, lyrics, comments ...',
  'songbook.listen': 'Listen',
  'songbook.listenPlaceholder': 'Link to audio file (.mp3, .ogg, .wav ...)',
  'songbook.listenInvalidUrl': 'Please provide an audio file (.mp3, .ogg, .wav, .flac, .aac, .m4a)',
  'songbook.elementNote': 'Note',
  'songbook.elementNotePlaceholder': 'Note for this block ...',
  'songbook.back': 'Back',
  'songbook.share': 'Share',
  'songbook.shareLink': 'Share link',
  'songbook.shareCopied': 'Link copied!',
  'songbook.shareStop': 'Stop sharing',
  'songbook.sharedBy': 'Shared by',
  'songbook.files': 'Files',
  'songbook.addFile': 'Add file',
  'songbook.fileUploading': 'Uploading...',
  'songbook.fileDeleteConfirm': 'Delete file?',
  'songbook.noFiles': 'No files',
  'songbook.addTablature': 'Tablature',
  'songbook.addImage': 'Image',
  'songbook.addMidi': 'MIDI',
  'songbook.tablatureImport': 'Paste tab',
  'songbook.preview': 'Preview',
  'songbook.edit': 'Edit',
  'songbook.pdf': 'Save as PDF',
  'songbook.export': 'Export backup',
  'songbook.import': 'Import backup',
  'songbook.exportSuccess': 'Backup downloaded.',
  'songbook.importSuccess': '{{collections}} collections and {{songs}} songs imported.',
  'songbook.importError': 'Import failed.',

  // Collections
  'songbook.collection': 'Collection',
  'songbook.collections': 'Collections',
  'songbook.newCollection': 'New Collection',
  'songbook.collectionName': 'Collection name',
  'songbook.addToCollection': 'Add to collection',
  'songbook.newCollectionStart': 'Start new collection',
  'songbook.artist': 'Artist / Band',
  'songbook.artistPlaceholder': 'e.g. The Beatles, Bach, ...',
  'songbook.collectionHint': 'A collection can be a setlist, album, compilation, or project.',
  'songbook.deleteCollection': 'Delete collection',
  'songbook.deleteCollectionConfirm': 'Delete empty collection?',
  'songbook.deleteCollectionNotEmpty': 'Collection still contains songs. Please delete all songs first.',
  'songbook.noCollections': 'No collections yet.',
  'songbook.renameCollection': 'Rename collection',
  'songbook.tapToRename': 'Double-tap to rename',
  'songbook.addToPlaylist': 'Add {{count}} songs to playlist',
  'songbook.selectPlaylist': 'Select playlist',
  'songbook.newPlaylistName': 'New playlist...',
  'songbook.createPlaylist': 'Create',
  'songbook.addedToPlaylist': 'Added to playlist',
  'songbook.playlistCreated': 'Playlist created',
  'songbook.playlists': 'Playlists',
  'songbook.noPlaylists': 'No playlists yet.',
  'songbook.deletePlaylistConfirm': 'Delete playlist? (Songs will not be deleted)',
  'songbook.removeFromPlaylist': 'Remove from playlist',
  'songbook.songsCount': '{{count}} songs',
  'songbook.liveOpacity': 'Color opacity',
  'songbook.liveFontSize': 'Font size',
  'songbook.fontSize.small': 'Small',
  'songbook.fontSize.medium': 'Medium',
  'songbook.fontSize.large': 'Large',
  'songbook.enterFullscreen': 'Fullscreen',
  'songbook.exitFullscreen': 'Exit fullscreen',

  // Instruments
  'songbook.instrument.guitar': 'Guitar',
  'songbook.instrument.bass': 'Bass',
  'songbook.instrument.keyboard': 'Keyboard',
  'songbook.instrument.custom': 'Custom',
  'songbook.customInstrumentName': 'Instrument name',

  // Songbook Sections
  'songbook.section.intro': 'Intro',
  'songbook.section.strophe': 'Verse',
  'songbook.section.refrain': 'Chorus',
  'songbook.section.bridge': 'Bridge',
  'songbook.section.mittelteil': 'Middle Part',
  'songbook.section.solo': 'Solo',
  'songbook.section.coda': 'Coda',
  'songbook.section.custom': 'Custom',
  'songbook.customSectionName': 'Section name',

  // Offline
  'offline.cacheSong': 'Save offline',
  'offline.includeAudio': 'Include audio files',
  'offline.noAudioFiles': 'No audio files',
  'offline.files': 'files',
  'offline.startCache': 'Save',
  'offline.caching': 'Saving...',
  'offline.cachingSong': 'Saving song',
  'offline.cachingImage': 'Saving image',
  'offline.cacheSuccess': 'Song available offline',
  'offline.cacheFailed': 'Offline save failed',
  'offline.title': 'Offline songs',
  'offline.songs': 'Songs',
  'offline.empty': 'No songs saved offline yet.',
  'offline.removeFromOffline': 'Remove from offline',
  'offline.storage': 'Storage usage',
  'offline.persistGranted': 'Persistent storage granted',
  'offline.persistMissing': 'Storage may be cleared automatically',
  'offline.persistRequest': 'Make storage persistent',
  'offline.openOfflinePage': 'Manage offline storage',
  'offline.disabled': 'Offline mode is not enabled.',
  'offline.pendingSync': '{{count}} not yet synced',
  'offline.pendingSyncHint': 'These were created offline and will upload as soon as network is back.',
  'offline.syncNow': 'Sync now',
  'offline.syncing': 'Syncing...',
} as const
